var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadAva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    height: 20,
    width: 20,
    y: 10,
    x: 10,
    maskUnits: "userSpaceOnUse",
    id: "mask0_3034_26707"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    fill: "#D9D9D9",
    height: 20,
    width: 20,
    y: 10,
    x: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2",
    fill: "#1C63D5",
    rx: 20,
    height: 40,
    width: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#F2F4F6",
    d: "m15.41669,26.62498c-1.26389,0 -2.34362,-0.4375 -3.23917,-1.3125c-0.89611,-0.875 -1.34417,-1.9444 -1.34417,-3.2083c0,-1.0833 0.32639,-2.0486 0.97917,-2.89582c0.65278,-0.84722 1.50694,-1.38889 2.5625,-1.625c0.23611,-1 0.82639,-1.95139 1.77083,-2.85417c0.94445,-0.90277 1.95139,-1.35416 3.02084,-1.35416c0.45833,0 0.85085,0.16305 1.17745,0.48916c0.3262,0.32667 0.4892,0.71917 0.4892,1.1775l0,5.04169l1.3333,-1.29168l1.1667,1.16668l-3.33332,3.3333l-3.33333,-3.3333l1.16666,-1.16668l1.33334,1.29168l0,-5.04169c-1.05556,0.19445 -1.875,0.70473 -2.45834,1.53084c-0.58333,0.82666 -0.875,1.6775 -0.875,2.5525l-0.41666,0c-0.80556,0 -1.49306,0.28472 -2.0625,0.85415c-0.56945,0.5695 -0.85417,1.257 -0.85417,2.0625c0,0.8056 0.28472,1.4931 0.85417,2.0625c0.56944,0.5695 1.25694,0.8542 2.0625,0.8542l9.99995,0c0.5834,0 1.0764,-0.2014 1.4792,-0.6042c0.4028,-0.4028 0.6042,-0.8958 0.6042,-1.4792c0,-0.5833 -0.2014,-1.0763 -0.6042,-1.4791c-0.4028,-0.4028 -0.8958,-0.6042 -1.4792,-0.6042l-1.25,0l0,-1.66665c0,-0.66667 -0.1527,-1.28833 -0.4583,-1.865c-0.3055,-0.57611 -0.7083,-1.06556 -1.2083,-1.46834l0,-1.9375c1.0278,0.48612 1.8403,1.205 2.4375,2.15667c0.5972,0.95111 0.8958,1.98917 0.8958,3.11417c0.9583,0.11111 1.7536,0.52417 2.3858,1.23915c0.6317,0.7156 0.9475,1.5525 0.9475,2.5108c0,1.0417 -0.3644,1.9273 -1.0933,2.6567c-0.7294,0.7289 -1.615,1.0933 -2.6567,1.0933l-9.99995,0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAva);
export default __webpack_public_path__ + "static/media/DownloadAva.28850e5049b3a68ed6e23f129c23892d.svg";
export { ForwardRef as ReactComponent };